// v-for="data in props.tableData.data" :key="data._id"
<template>
  <div class="app__trow">
    <!-- DEPARTMETNS FIELDS -->
    <div class="app__tdata" v-if="rowData.name">{{rowData.name}}</div>
    <div class="app__tdata" v-if="rowData.login">{{rowData.login}}</div>
    <div class="app__tdata" v-if="rowData.email">{{rowData.email}}</div>
    <div class="app__tdata" v-if="rowData.setor">{{rowData.setor}}</div>
    <!-- ACTION BTN -->
    <div class="app__tdata action" v-if="rowData.action">
      <button
        class="sgnup__btn is-relative"
        @click="active=!active"
        @mouseleave="active=false"
        :style="active?'cursor:unset':''"
      >
        <i class="fas fa-ellipsis-h"></i>
        <div class="app__taction-tab" v-show="active">
          <div class="app__taction-head">Opções</div>
          <span class="app__taction-btn" @click="$emit('edit-item',rowData._id)">Editar</span>
          <!-- <span class="app__taction-btn" @click="$emit('deleteItem',rowData._id)">Excluir</span> -->
        </div>
      </button>
    </div>
  </div>
</template>
<script>
import config from "../config";
export default {
  props: {
    rowData: null
  },
  data() {
    return {
      active: false,
      conf: config
    };
  },
  mounted() {
    console.log(this.rowData.avatarUrl);
  }
};
</script>

